import { createRoot } from 'react-dom/client';
import PublicStandingsApp from './PublicStandingsApp';
import './styles/public-standings.css';

const container = document.getElementById('fairplay-rules-public-standings');

if (container) {
	const root = createRoot(container);
	root.render(<PublicStandingsApp />);
}